import { type FilterEntityType } from "entity/filters/Filter/Filter.api.types";

export type SavedFilterFormActions = undefined | "save" | "update" | "delete";

export interface ISavedFilterFormValues {
    filterType: FilterEntityType;
    filterName: string;
    isDefault: boolean;
    isPrivate: boolean;
    selectedFilter: number;
    value: any;
}

export interface IApiSavedFilterItem {
    id: number;
    isDefault?: boolean;
    isMobileDefault?: boolean;
    isOwner?: boolean;
    canEdit?: boolean;
    isPrivate?: boolean;
    name?: string;
    nameAndUpdatedBy?: string;
    value?: string | object;
}

interface IApiSavedFilterEntity {
    savedFilters: IApiSavedFilterItem[];
}

export class SavedFilterEntity {
    constructor(data: IApiSavedFilterEntity) {
        this.savedFilters = data.savedFilters.map(
            (savedFilter: IApiSavedFilterItem) => new SavedFilterItem(savedFilter),
        );
    }

    savedFilters: SavedFilterItem[];
}

export class SavedFilterItem {
    constructor(data: IApiSavedFilterItem) {
        this.id = data.id;
        this.isDefault = data.isDefault ?? false;
        this.isMobileDefault = data.isMobileDefault ?? false;
        this.isOwner = data.isOwner ?? false;
        this.canEdit = data.canEdit ?? false;
        this.isPrivate = data.isPrivate ?? false;
        this.name = data.name ?? "";
        this.nameAndUpdatedBy = data.nameAndUpdatedBy ?? "";
        // Normalize value to always be a string
        // Handle Apple Mail iPad bug where value comes as an object instead of string
        this.value =
            typeof data.value === "string"
                ? data.value
                : typeof data.value === "object" && data.value !== null
                  ? JSON.stringify(data.value)
                  : "{}"; // Empty JSON object for undefined/null/empty cases
    }

    id: number;
    isDefault: boolean;
    isMobileDefault: boolean;
    isOwner: boolean;
    canEdit: boolean;
    isPrivate: boolean;
    name: string;
    nameAndUpdatedBy: string;
    value: string;
}

export class SavedFilterDeleteResponse {}

export class SavedFilterUpdateResponse {}

export class SavedFilterCreateResponse {
    constructor(data: any) {
        this.id = data.id;
    }
    id: number;
}

export class SavedFilterSetUserDefaultResponse {}
